import React, {useEffect, useState} from 'react';
import SearchAndSelectModal from "../../theme/modals/SearchAndSelectModal";
import api from "../../../store/api";
import {addErrorAlert, toggleGlobalLoader} from "../../../store/calls/alertLoadingDispatch";


function TemplateMergeModal({visible, onClose, onSelect}) {

    const [selected, setSelected] = useState(false);
    const [templates, setTemplates] = useState([]);



    useEffect(() => {
        pullMergeableTemplates();

    }, [])


    const pullMergeableTemplates = (search = null) => {
        toggleGlobalLoader(true);
        return api.get('/application-templates', {short: true, search})
            .then(res => setTemplates(res.data))
            .catch(() => addErrorAlert("Failed to pull templates that can be merged."))
            .then(() => toggleGlobalLoader(false))
    }


    const renderMergeableTemplateOption = (template) => {
        return (
            <div className="card m-2 is-clickable" onClick={() => {
                onSelect(template.id)
            }}>
                <div className="card-content">
                    <h6 className="is-size-5 has-text-primary">{template.name}</h6>
                    <h7 className="is-size-7">{template.funder}</h7>
                </div>
            </div>
        )
    }

    return (
        <SearchAndSelectModal
            title="Select a Template To Merge"
            visible={visible}
            onCancel={onClose}
            handleSearch={(val) => {
                pullMergeableTemplates(val);
            }}
            results={templates}
            renderResultElement={renderMergeableTemplateOption}
        />
    )
}


export default TemplateMergeModal